
import React from "react";

export default function BrandPhilosophy() {
  return (
    <section
      className="min-h-[80vh] sm:min-h-screen bg-white flex items-center py-16 sm:py-24 md:py-32"
      aria-labelledby="philosophy-heading"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 w-full">
        <div className="grid md:grid-cols-2 gap-10 sm:gap-16 md:gap-20 items-center">
          <div>
            <h2
              id="philosophy-heading"
              className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-black mb-4 sm:mb-6 tracking-tight"
            >
              Work &amp; Play.
            </h2>
            <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-light text-black/60 mb-8 sm:mb-12 tracking-wide">
              どちらも、ジブンの人生だ。
            </p>
          </div>
          <div className="space-y-6 sm:space-y-8">
            <p className="text-base sm:text-lg md:text-xl font-light text-black/80 leading-relaxed">
              働く時間と、遊ぶ時間。<br />
              集中と、解放。<br />
              合理性と、感性。
            </p>
            <p className="text-base sm:text-lg md:text-xl font-light text-black/80 leading-relaxed">
              どちらかを削るのではなく、どちらも最大化する。<br />
              それがMeVERの思想です。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
